import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import ReasonModal from "../ReasonModal";
import {
  AddCircle,
  ArrowForwardSquare,
  ArrowRotateRight,
  CloseCircle,
  Edit2,
  Eye,
  TickCircle,
  Trash,
} from "iconsax-react";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import { useLoader } from "../../Loader";
import LogModal from "./LogModal";
import RejectModal from "./RejectModal";

function List(props) {
  const [assetsList, setassetsList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const { startLoader, stopLoader } = useLoader();
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "Add",
    };
    props.onChange(propdata);
  };

  const permissions = [
    {
      approve: "moveorder.Production_approve",
      reject: "moveorder.Production_reject",
      titleA: "Production Approval",
      titleR: "Production Reject",
      status: "1",
    },
    {
      approve: "moveorder.Finance_approve",
      reject: "moveorder.Finance_reject",
      titleA: "Finance Approval",
      titleR: "Finance Reject",
      status: "2",
    },
    {
      approve: "moveorder.Facility_approve",
      reject: "moveorder.Facility_reject",
      titleA: "Facility Approval",
      titleR: "Facility Reject",
      status: "3",
    },
    {
      approve: "moveorder.CEO_approve",
      reject: "moveorder.CEO_reject",
      titleA: "CEO Approval",
      titleR: "CEO Reject",
      status: "4",
    },
    {
      approve: "moveorder.CFO_approve",
      reject: "moveorder.CFO_reject",
      titleA: "CFO Approval",
      titleR: "CFO Reject",
      status: "5",
    },
  ];

  const renderPermissionButtons = (row) =>
    permissions
      .filter((perm) => perm.status == row.status)
      .map((perm, index) => (
        <React.Fragment key={index}>
          {utils.hasPermission(primaryMenuRes, "Move Order", perm.approve) && (
            <RB.Button
              className="btn-flat ms-1"
              title={`${perm.titleA}`}
              onClick={handleApprove(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "Move Order", perm.reject) && (
            <RB.Button
              className="btn-flat ms-1"
              title={`${perm.titleR}`}
              onClick={handleReject(row)}
            >
              <CloseCircle />
            </RB.Button>
          )}
        </React.Fragment>
      ));

  const columns = [
    {
      name: (
        <div>
          Move Order No. <br />
        </div>
      ),
      selector: (row, index) => row.move_order_no,
    },
    {
      name: (
        <div>
          Equipment Name <br />
        </div>
      ),
      selector: (row, index) => row.equipment_name,
    },
    {
      name: (
        <div>
          Equipment No. <br />
        </div>
      ),
      selector: (row, index) => row.equipment_no,
    },
    {
      name: "Assets No.",
      selector: (row, index) => row.asset_code_no,
    },
    {
      name: "Assets tag No.",
      selector: (row, index) => row.asset_tag_no,
    },
    {
      name: (
        <div>
          Assets Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    // {
    //   name: "Plant Name",
    //   selector: (row, index) => row?.current_assets.plant_name,
    // },
    // {
    //   name: "Location",
    //   selector: (row, index) => row?.current_assets.location_name,
    // },
    {
      name: "Status",
      selector: (row, index) => row.status_label,
      width: "250px",
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat ms-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
          {utils.hasPermission(
            primaryMenuRes,
            "Move Order",
            "moveorder.edit"
          ) && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Move Order",
            "moveorder.edit_for_Finance"
          ) && (
            <>
              {row?.status == "2" && (
                <RB.Button
                  className="btn-flat ms-1 me-1"
                  title="Edit"
                  onClick={handeFMlEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Move Order",
            "moveorder.delete"
          ) && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Delete"
                  onClick={showDelete(row)}
                >
                  <Trash />
                </RB.Button>
              )}
            </>
          )}
          {renderPermissionButtons(row)}
        </>
      ),
    },
  ];
  const handeFMlEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "moveOrder",
      rowData: row,
    };
    props?.setIsEdit(true);
    props.onChange(propdata);
  });

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.install_log);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleReject = useCallback((row) => async () => {
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  useEffect(() => {
    getassetsList();
  }, [page]);

  const getassetsList = () => {
    startLoader();
    utils
      .callAPI("get", `moveorder/list?page=${page}&per_page=${countPerPage}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setassetsList(res);
          stopLoader();
          // setFilter(false)
        } else {
          setassetsList([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setassetsList([]);
        stopLoader();
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.setIsEdit(true);
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/moveorder/delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getassetsList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleApprove = useCallback((row) => async () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("move_order_id", row.id);
    bodyFormData.append("status", "accept");
    bodyFormData.append("reject_reason", "");

    utils
      .callAPI("post", `/moveorder/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getassetsList();
          stopLoader();
        } else {
          getassetsList();
          stopLoader();
        }
      })
      .catch((err) => {
        getassetsList();
        stopLoader();
      });
  });

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            {/* {utils.hasPermission(primaryMenuRes, "Assets", "assets.create") && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )} */}
          </div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Move Order",
              "moveorder.view"
            ) && (
              <>
                <DataTable
                  columns={columns}
                  data={assetsList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={assetsList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={assetsList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <RejectModal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        onReject={handleReject}
        selectedOrder={selectedOrder}
        getassetsList={getassetsList}
      />
    </>
  );
}

export default List;
